var chunkMapping = {
	"0": [
		4647
	],
	"74": [
		5046
	],
	"150": [
		5122
	],
	"151": [
		5123
	],
	"154": [
		5126
	],
	"155": [
		5127
	],
	"156": [
		5128
	],
	"157": [
		5129
	],
	"158": [
		5130
	],
	"159": [
		5131
	],
	"160": [
		5132
	],
	"161": [
		5133
	],
	"162": [
		5134
	],
	"163": [
		5135
	],
	"164": [
		5136
	],
	"165": [
		5137
	],
	"166": [
		5138
	],
	"167": [
		5139
	],
	"168": [
		5140
	],
	"169": [
		5141
	],
	"170": [
		5142
	]
};
var idToExternalAndNameMapping = {
	"4647": [
		"default",
		"./Containers",
		3800
	],
	"5046": [
		"default",
		"./OrderlessInvoices",
		3800
	],
	"5122": [
		"default",
		"./AsyncEventTracker",
		3800
	],
	"5123": [
		"default",
		"./HostWrapper",
		3800
	],
	"5126": [
		"default",
		"./CheckoutV3",
		3800
	],
	"5127": [
		"default",
		"./CheckoutConfirmation",
		3800
	],
	"5128": [
		"default",
		"./ContactCreditCards",
		3800
	],
	"5129": [
		"default",
		"./AuditDialog",
		3800
	],
	"5130": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3800
	],
	"5131": [
		"default",
		"./InvoiceDialog",
		3800
	],
	"5132": [
		"default",
		"./PaymentDueModal",
		3800
	],
	"5133": [
		"default",
		"./PaymentModal",
		3800
	],
	"5134": [
		"default",
		"./PaymentHistory",
		3800
	],
	"5135": [
		"default",
		"./PaymentConfigurations",
		3800
	],
	"5136": [
		"default",
		"./PaymentPreferences",
		3800
	],
	"5137": [
		"default",
		"./ManagePaymentProcessing",
		3800
	],
	"5138": [
		"default",
		"./MobilePaymentsWrapper",
		3800
	],
	"5139": [
		"default",
		"./Challenge",
		3800
	],
	"5140": [
		"default",
		"./ManagePaymentMethods",
		3800
	],
	"5141": [
		"default",
		"./LightspeedReports",
		3800
	],
	"5142": [
		"default",
		"./ShippingPromotionsListContainer",
		3800
	]
};
var idToRemoteMap = {
	"4647": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5046": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5122": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5123": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5126": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5127": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5128": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5129": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5130": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5132": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5133": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5134": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5142": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}